import type { GameTypePlugin, GameRenderer, GameConfigurator, GameRendererCapabilities } from '../../interfaces/game-type-plugin.interface';
import { DiceRollRenderer } from './dice-roll-renderer';
import type { DiceRollSettings, DiceRollSurfaceOrientation, DiceRollLegendOrientation } from './dice-roll.types';

/**
 * Dice Roll Plugin
 *
 * Implements the GameTypePlugin interface for dice roll experiences.
 * Two-dice game with instant prize results based on dice total (2-12).
 */
export class DiceRollPlugin implements GameTypePlugin {
  readonly id = 'dice-roll';
  readonly name = 'Dice Roll';
  readonly description = 'Two-dice game with instant prize results and legend display';
  readonly version = '1.0.0';

  readonly capabilities: GameRendererCapabilities = {
    mode: 'html-in-3d',          // HTML legend + 3D dice
    requires3DScene: true,       // Needs 3D dice and table surface
    requiresHTMLContainer: true, // Needs HTML for legend layout
    supportsAR: true,            // Fully supports AR mode
    supportsVR: false            // VR not yet supported
  };

  createRenderer(): GameRenderer {
    return new DiceRollRenderer();
  }

  createConfigurator(): GameConfigurator {
    return {
      getDefaultConfig: (): DiceRollSettings => ({
        type: 'dice-roll',
        surfaceOrientation: 'horizontal' as DiceRollSurfaceOrientation,
        legendOrientation: 'horizontal' as DiceRollLegendOrientation,
        prizeColors: undefined,
        logoUrl: undefined,
        castShadow: true,
        enableCameraControls: false
      }),
      validateConfig: (config: DiceRollSettings) => {
        // No validation needed for current settings
        return [];
      },
      getConfigSchema: () => ({
        sections: [
          {
            title: 'Game Settings',
            fields: [
              // Future: Add form fields for game board configurator
            ]
          }
        ]
      })
    };
  }
}
